import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { Select } from "antd";
import ConsultationService from "../../../../Services/ConsultationService";

export default function Diagnosis() {
  const dispatch = useDispatch();
  const dischargeDiagnosis = useSelector(
    (state) => state.discharge?.dischargeDiagnosis || []
  );

  const [selectedType, setSelectedType] = useState("PRIMARY");
  const [selectedCode, setSelectedCode] = useState(null);
  const [diagnosticList, setDiagnosticList] = useState([]);

  const handleIcdDrescriptionSearch = async (value) => {
    if (value.length > 2) {
      let payload = {
        description: value,
        pageSize: 50,
        status: 1,
      };

      try {
        let result = await ConsultationService.ICDData(payload);
        setDiagnosticList(result.data || []);
      } catch (error) {
        setDiagnosticList([]);
      }
    }
  };

  const handleIcdCodeSearch = async (value) => {
    if (value.length > 2) {
      let payload = {
        code: value,
        pageSize: 50,
        status: 1,
      };

      try {
        let result = await ConsultationService.ICDData(payload);
        setDiagnosticList(result.data || []);
      } catch (error) {
        setDiagnosticList([]);
      }
    }
  };

  const handleAddDiagnosis = () => {
    if (!selectedCode) return;
    dispatch(
      addDischargeArrayItem("dischargeDiagnosis", {
        diagnosisCode: selectedCode.code,
        diagnosisDesc: selectedCode.description,
        diagnosisSeq: dischargeDiagnosis.length + 1,
        diagnosisStatus: "CONFIRMED",
        diagnosisSystem: "ICD10",
        diagnosisType: selectedType,
        presentOnAdmission: "Y",
        remarks: "",
        status: 1,
        activeFlag: "Y",
      })
    );
    setSelectedCode(null);
  };

  const handleRemoveDiagnosis = (index) => {
    dispatch(removeDischargeArrayItem("dischargeDiagnosis", index));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 flex items-center gap-2 mb-4">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        2. Diagnosis
      </h3>

      <div className="flex flex-col gap-4">
        <div className="flex space-x-4">
          <label className="flex items-center space-x-2 text-gray-700">
            <input
              type="radio"
              name="diagnosisType"
              value="PRIMARY"
              checked={selectedType === "PRIMARY"}
              onChange={(e) => setSelectedType(e.target.value)}
              className="w-4 h-4 text-[#189FAA] focus:ring-[#189FAA]"
            />
            <span className="text-xs text-[#333333] font-sans font-medium">
              Primary
            </span>
          </label>
          <label className="flex items-center space-x-2 text-gray-700">
            <input
              type="radio"
              name="diagnosisType"
              value="SECONDARY"
              checked={selectedType === "SECONDARY"}
              onChange={(e) => setSelectedType(e.target.value)}
              className="w-4 h-4 text-[#189FAA] focus:ring-[#189FAA]"
            />
            <span className="text-xs text-[#333333] font-sans font-medium">
              Secondary
            </span>
          </label>
        </div>

        <div className="flex items-center w-full gap-3">
          <div className="flex flex-col space-y-2 w-1/2">
            <Select
              showSearch
              placeholder="Disease Condition"
              className="h-10 w-full"
              onSearch={handleIcdDrescriptionSearch}
              onChange={(value, option) => setSelectedCode(option?.data)}
              value={selectedCode?.description || undefined}
              options={diagnosticList?.map((des) => {
                return {
                  label: des.description,
                  value: des.code,
                  data: des,
                };
              })}
              filterOption={(input, option) =>
                option &&
                option.label &&
                option.label.toUpperCase().indexOf(input.toUpperCase()) >= 0
              }
              allowClear
              notFoundContent={null}
            />
          </div>
          <div className="flex flex-col space-y-2 w-1/2">
            <Select
              showSearch
              placeholder="ICD Code"
              className="h-10 w-full"
              onSearch={handleIcdCodeSearch}
              onChange={(value, option) => setSelectedCode(option?.data)}
              value={selectedCode?.code || undefined}
              options={diagnosticList?.map((des) => {
                return {
                  label: des.code,
                  value: des.code,
                  data: des,
                };
              })}
              filterOption={(input, option) =>
                option &&
                option.label &&
                option.label.toUpperCase().indexOf(input.toUpperCase()) >= 0
              }
              allowClear
              notFoundContent={null}
            />
          </div>
          <button
            type="button"
            onClick={handleAddDiagnosis}
            className="w-10 h-10 mt-2 flex items-center justify-center bg-teal-50 text-teal-700 hover:bg-teal-100 rounded-md transition border border-teal-200"
          >
            <FiPlus className="w-5 h-5" />
          </button>
        </div>
      </div>

      {dischargeDiagnosis && dischargeDiagnosis.length > 0 && (
        <div className="flex flex-col w-full border border-gray-300 rounded-lg shadow-md mt-6">
          <div className="flex w-full bg-[#F5FEFA] text-[#333333] font-sans font-medium text-xs">
            <div className="p-2 border border-[#D2E1E2] text-center w-[20%]">
              Type
            </div>
            <div className="p-2 border border-[#D2E1E2] text-left w-[45%]">
              Disease Condition
            </div>
            <div className="p-2 border border-[#D2E1E2] text-center w-[20%]">
              ICD-10 Code
            </div>
            <div className="p-2 border border-[#D2E1E2] text-center w-[15%]">
              Action
            </div>
          </div>

          <div className="w-full">
            {dischargeDiagnosis.map((item, index) => (
              <div
                key={index}
                className="flex w-full text-teal-700 font-sans font-medium text-xs bg-white hover:bg-gray-100"
              >
                <div className="p-2 border border-gray-300 text-center w-[20%] font-bold">
                  {item.diagnosisType}
                </div>
                <div className="p-2 border border-gray-300 text-left w-[45%] text-gray-700">
                  {item.diagnosisDesc || "N/A"}
                </div>
                <div className="p-2 border border-gray-300 text-center w-[20%] text-gray-700">
                  {item.diagnosisCode || "N/A"}
                </div>
                <div className="p-2 border flex justify-center items-center gap-3 border-gray-300 text-center w-[15%]">
                  <button
                    onClick={() => handleRemoveDiagnosis(index)}
                    className="text-red-500 hover:text-red-700 transition bg-white"
                  >
                    <FiTrash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
